import Game from "./Game"
import { onePlaceGames, viewport } from "@/constants"
import { motion } from "framer-motion"

const item = {
  hidden: { opacity: 0, y: -10, scale: 0.95 },
  show: { opacity: 1, scale: 1, y: 0 },
  exit: { opacity: 0, y: 10, scale: 0.95 },
}

const AllGames = () => (
  <div className="h-[216px] w-full max-w-[466px] select-none sm:h-[232px] lg:max-w-none">
    {onePlaceGames.map((game) => (
      <motion.div
        key={game.players}
        initial="hidden"
        whileInView="show"
        exit="exit"
        viewport={viewport}
        variants={item}
        className="py-1"
      >
        <Game {...game} />
      </motion.div>
    ))}
  </div>
)

export default AllGames
